import React from 'react'

const RelationDocs = ({ value, document }) => {
  const isQuotation = value?.Type === 'quote'
  const isElectronicInvoice = value.Type === 'electronicInvoice'
  const isODC = value.Type === 'purchaseOrders'

  const name = value.Name
  const basePath = value.Path
  const path = isQuotation
    ? `${value?.DocumentTypeId}/${value?.DocumentNumber}`
    : value?.DocumentTypeId

  const openPDF = url => {
    const newTab = window.open()
    if (newTab) {
      newTab.document.write(`
        <embed src="${url}" width="100%" height="100%" type="application/pdf" />
      `)
    }
  }

  const handleClick = e => {
    if (isODC && value?.PdfUrl) {
      e.preventDefault()
      openPDF(value.PdfUrl)
    }
  }

  const element = (
    <a
      href={
        isElectronicInvoice && value?.UrlCAFEInDGI
          ? value.UrlCAFEInDGI
          : isODC
          ? '#'
          : `${basePath}${path}`
      }
      target="_blank"
      role="link"
      onClick={handleClick}
      rel="noreferrer">
      {isElectronicInvoice ? `FE${value.Cufe}` : value?.DocumentNumber}
    </a>
  )

  return (
    <span>
      {name}: {element}
    </span>
  )
}

export default RelationDocs
